import actionCreatorFactory from 'typescript-fsa';

import * as store from './store';
import * as Sentry from '@sentry/browser';

const actionCreator = actionCreatorFactory();

export const setLoggedInPatient = actionCreator<store.Patient>(
  'SET_LOGGED_IN_PATIENT',
);
export function setLoggedInPatientHandler(
  state: store.All,
  loggedInPatient: store.Patient,
): store.All {
  if (loggedInPatient) {
    Sentry.setUser({
      id: loggedInPatient.id,
    });
  }
  return {
    ...state,
    loggedInPatient,
  };
}
